// The answer document's envelope. Section groups are created on demand, keyed
// by the section.key the server sends, so a new section needs no change here.
export const emptyDoc = () => ({
  submitted: false,
  // Closed by the deadline. Server owned: refreshed from the payload on load.
  locked: false,
  acknowledged: false,
  revision: 0,
  current_section: null,
  section_updated_at: {},
});

// Answer groups are absent until touched, so every read goes through this.
export const groupOf = (doc, sectionKey) => doc[sectionKey] || {};
